import { Box } from '@mui/material';
import React from 'react';
import Plot from 'react-plotly.js';
import { basePlotConfig, useChartTheme } from '../overview/plotTheme';

const DailyPlot = ({
  tsSocMin,
  tsSocMax,
  tsSocUse,
  tsTemperatureMin,
  tsTemperatureMax,
}) => {
  const { colors, baseLayout: makeLayout, themeTrace } = useChartTheme();
  const baseLayout = makeLayout("SOC (%)");

  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      <Plot
        data={[
          tsSocMin,
          tsSocUse,
          tsTemperatureMin,
          tsTemperatureMax,
        ].map(themeTrace)}
        layout={{
          ...baseLayout,
          barmode: "stack",
          legend: { ...baseLayout.legend, x: 0, xanchor: "left" },
          yaxis: { ...baseLayout.yaxis, range: [0, 100] },
          yaxis2: {
            title: { text: "Cell temp. (°C)", font: { size: 12, color: colors.text }, standoff: 8 },
            overlaying: "y",
            side: "right",
            showgrid: false,
            zeroline: false,
            automargin: true,
          },
        }}
        config={basePlotConfig}
        useResizeHandler={true}
        style={{ width: "100%", height: "100%" }}
      />
    </Box>
  )
}

export default DailyPlot;
